import mock from 'mockjs'
import _ from 'underscore'

export const Mock = mock
export const underscore = _
const utils = {
    num (min, max) {
        const obj = {}
        obj[`number|${min}-${max}`] = max
        return Mock.mock(obj).number
    },
    nums (count, min, max) {
        let obj = {}
        let num_obj = {}
        num_obj["number|" + min + "-" + max] = max
        obj["array|" + (count || 1)] = [num_obj]
        return Mock.mock(obj).array.map(m => {
            return m.number
        })
    },
    arrayRadom (arr) {
        return Mock.mock({"array|1": arr}).array
    }
}
export const util = utils



// WEBPACK FOOTER //
// ./src/util/mockUtil.js